import React from 'react'
import { assets } from '@/helpers/common'
import Promotion from '@/components/sections/Promotion'
import Meta from '@/components/common/Meta'
import FeatureBox from '@/components/subComponents/FeatureBox'
import Link from 'next/link'
import { BOOK_NOW } from '@/router/allUrls'
import MovingStorageSolutionBanner from '@/components/banners/MovingStorageSolutionBanner'
import { META_CONTENTS } from '@/v1/constants/seo'

const features = [
  {
    title: 'Find Location',
    icon: assets('images/moving-storage/feature-01.png'),
    content:
      'Looking for a storage service that perfectly matches your needs? Look no further! Select our hassle-free storage solutions and confidently place your order online now.'
  },
  {
    title: 'We Move & Store',
    icon: assets('images/moving-storage/feature-02.png'),
    content:
      'We pick up and store your items in our warehouse. Up-to 6 months of free storage. Save time and store your belongings with our secure storage services at simple pricing and a wide range of delivery options.'
  },
  {
    title: 'We Ship',
    icon: assets('images/moving-storage/feature-03.png'),
    content:
      'With our easy-to-use online platform, you can create a new shipment whenever you want. Our reliable and efficient door-to-door delivery services are available to you no matter where you are in the world.'
  }
]
const features_two = [
  {
    title: 'Convenient Storage',
    icon: assets('images/moving-storage/feature-04.png'),
    content:
      'Are your changing home? Or left current home and waiting/searching for a new home? Going to another country? No problem! Just use our smart storage which is free for up to 6 months. And ship conveniently anywhere.'
  },
  {
    title: 'Simplest Pricing',
    icon: assets('images/moving-storage/feature-05.png'),
    content:
      'After ending free storage days, you are going to pay only $10/month for each luggage or box! That is really cool. Also, we offer very transparent pricing that is  cheaper ever than other service providers.'
  },
  {
    title: 'Shipment With FedEx',
    icon: assets('images/moving-storage/feature-06.png'),
    content:
      'We have partnership with FedEx. No matter wherever you are! FedEx shipping people will come at your door and pick up your belongings easily, or you can drop off your stuffs directly at our warehouse.'
  },
  {
    title: 'Ship Internationally ',
    icon: assets('images/moving-storage/feature-07.png'),
    content:
      'Moreover, if you are going too far away from your city or to another country, we can pack and ship your items anywhere. As we allow domestic and international shipment. You do not need to come back again to get your belongings at our storage facility.'
  }
]

function MovingStorageSolution() {
  return (
    <>
      <Meta
        title={META_CONTENTS.moving_storage.title}
        keywords={META_CONTENTS.moving_storage.keywords}
        description={META_CONTENTS.moving_storage.description}
      />

      <MovingStorageSolutionBanner />

      <section className='mobile-banner-content-section md-mn:hidden pt-10 pb-40 sm-mx:pt-12 sm-mx:pb-2'>
        <div className='container mx-auto'>
          <div className='row sm-mx:flex-col-reverse'>
            <div className='w-full text-center'>
              <div className='banner-content text-center'>
                <h2 className='text-4xl2 font-bold text-secondary mb-4 sm-mx:text-2xl26 sm-mx:mb-1 xs:max-w-[320px] mx-auto'>
                  Moving Storage Now Made Easy
                </h2>
                <h3 className='text-2xl font-normal text-gray-400 mb-1 sm-mx:text-base'>
                  Move, store, and ship your luggage and boxes hassle-free with transparent prices. Ideal for large to
                  small business owners seeking reliable storage space, Ship and Storage is committed to providing
                  excellent and finest moving solutions for luggage storage, box storage, valet storage, international
                  shipping, etc. Take advantage of our affordable storage solutions today!
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='how-moving-storage-work-section pt-40 pb-14 md-mx:pt-32 sm-mx:pt-10'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>How Moving Storage Work</h2>
                <p>Pack your valuable items in luggage and boxes, we will pick up from your door and store for you.</p>
              </div>
            </div>
          </div>
          <div className='pt-20 sm-mx:pt-8 grid gap-y-10 lg-mx:gap-y-5 grid-cols-3 sm-mx:grid-cols-2 xs:grid-cols-1'>
            {features.map((item, key) => {
              return (
                <div key={key} className='px-5 lg-mx:px-0 text-center'>
                  <FeatureBox className='' title={item.title} icon={item.icon} content={item.content} />
                </div>
              )
            })}
          </div>

          <div className='row justify-center mt-20 sm-mx:mt-8'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>
                  With us, Avoid Paying Too Much <br />
                  Moving + Storage Charge!
                </h2>
                <p>
                  Wouldn't it be nice if you could just store your boxes at a self-storage facility and get them <br />
                  without having to go to a bad part of town and look for items?
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='moving-why-different-section bg-white-ice pt-16 pb-8'>
        <div className='container'>
          <div className='row justify-between'>
            <div className='w-5/12 md-mx:w-full text-right flex justify-center md-mx:justify-center items-start lg:items-center md-mx:mb-5 left-col'>
              <img
                className='inline-block'
                src={assets('images/moving-storage/feature_list_left.png')}
                alt='Why We Are Different?'
              />
            </div>
            <div className='w-7/12 md-mx:w-full right-col md-mx:text-center'>
              <ul className='list-style-one md-mx:inline-block md-mx:text-left'>
                <li className='text-lg mb-3'>You don’t need to pay for a whole truck for limited stuffs.</li>
                <li className='text-lg mb-3'>We can move even single item.</li>
                <li className='text-lg mb-3'>Simply pack yourself and we will pick up from your door.</li>
                <li className='text-lg mb-3'>You do not need to pay for extra space that you won’t need.</li>
                <li className='text-lg mb-3'>Just pay for single box or luggage that you are storing with us!</li>
              </ul>
              <Link href={BOOK_NOW} className='btn btn-primary get-started shadow'>
                Get Started
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className='we-simplified-moving-section pt-24 pb-14 md-mx:pt-12 sm-mx:pt-10 sm-mx:pb-6'>
        <div className='container'>
          <div className='row justify-center'>
            <div className='w-full text-center'>
              <div className='section-title effect text-center'>
                <h2 className='inline-block'>We Simplified Moving</h2>
                <p>We are your best partner for moving your belongings to your new house or to another country</p>
              </div>
            </div>
          </div>
          <div className='pt-20 sm-mx:pt-10 grid gap-y-10 lg-mx:gap-y-5 grid-cols-4 md-mx:grid-cols-2 sm-mx:grid-cols-2 xs:grid-cols-1'>
            {features_two.map((item, key) => {
              return (
                <div key={key} className='px-5 lg-mx:px-0 text-center'>
                  <FeatureBox className='style-four' title={item.title} icon={item.icon} content={item.content} />
                </div>
              )
            })}
          </div>
        </div>
      </section>

      <Promotion className='moving-promotion'>
        <>
          <img className='sm-mx:hidden' src={assets('images/promotion-bg-two.png')} alt={''} />
          <div className='promotion-inner flex justify-center items-center'>
            <div className='promotion-content inline-block text-center pt-48 md-mx:pt-36 sm-mx:pt-0'>
              <p className='text-3xl mb-2 md-mx:text-lg md-mx:mb-0'>Photos, clothing, toys, gifts, and more can be</p>
              <h2>Moved + stored + shipped safely! </h2>
              <p className='text-3xl mb-10 md-mx:text-lg md-mx:mb-5'>We are the cheapest option for you.</p>
              <Link href={BOOK_NOW} className='btn btn-primary'>
                Get Started
              </Link>
              <p className='text-sas-gray-400 text-sm13 font-medium'>
                A valet storage experience that you will love it
              </p>
            </div>
          </div>
        </>
      </Promotion>
    </>
  )
}

export default MovingStorageSolution
